import { parsePhoneNumberWithError } from 'libphonenumber-js'
import { string, preprocess, email as _email } from 'zod'


export let inn = string().regex(/^\d{10}$|^\d{12}$/)


export let phone = preprocess((input: string) => {
  try {
    let phoneNumber = parsePhoneNumberWithError(input, 'RU')
    if (phoneNumber.isValid()) {
      return phoneNumber.number
    }
  } catch {
  }
  return ''
}, string().superRefine((value, ctx) => {
  if (!value)
    ctx.addIssue({
      code: 'invalid_format',
      message: 'Неправильный номер телефона.',
      format: 'e164'
    })
}))


export let email = string().trim().check(_email()).toLowerCase()
